import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive } from "utils/Constant"
import { ApiGetBankList, ApiGetBeneficiaryAccountList, ApiGetTransferSourceById, ApiInsertTransferSource, ApiUpdateTransferSource } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { GetStatus } from "utils/helpers"
import Select from 'react-select'
import Dropdown from "components/Input/Dropdown"
import { useModal } from "utils/context/ModalContext"
import { useCallApi } from "api/apiHooks"

export default function TransferSourceFormModal({ isOpen, onClose, data, transferSourceId, formType }) {
    const navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const {  } = useCallApi()

    const { fetch: apiInsertTransferSource } = useFetch(ApiInsertTransferSource)
    const { fetch: apiUpdateTransferSource } = useFetch(ApiUpdateTransferSource)
    const { fetch: apiGetBankList } = useFetch(ApiGetBankList)
    const { fetch: apiGetBeneficiaryList } = useFetch(ApiGetBeneficiaryAccountList)
    const { fetch: apiGetTransferSource } = useFetch(ApiGetTransferSourceById)

    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [sourceName, setSourceName] = useState(EmptyString)    
    const [beneficiaryOptions, setBeneficiaryOptions] = useState([])
    const [beneficiaryId, setBeneficiaryId] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errorBeneficiaryAccountNo, setErrorBeneficiaryAccountNo] = useState(false)
    const [errorMdrOff, setErrorMdrOff] = useState(false)
    const [errorBankId, setErrorBankId] = useState(false)
    
    const bankIdChange = (e) => { setBankId(e.value) }    
    const beneficiaryOnInput = (e) => { getBeneficiaryList(e) }
    const beneficiaryIdChange = (e) => { setBeneficiaryId(e) }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const insertTransferSource = async () => {
        await apiInsertTransferSource({
            data: {
                beneficiaryId : (beneficiaryId !== EmptyString && beneficiaryId !== null) ? beneficiaryId.value : EmptyString, 
                sourceName : sourceName
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/transaction-report") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const updateTransferSource = async () => {
        await apiUpdateTransferSource({
            data: {
                transferSourceId: transferSourceId,
                beneficiaryId : (beneficiaryId !== EmptyString && beneficiaryId !== null) ? beneficiaryId.value : EmptyString, 
                sourceName : sourceName
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            navigate("/setting/transfer-source") 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getTransferSource = async () => {
        await apiGetTransferSource({
            data: {
                transferSourceId: transferSourceId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setBankId(String(data.bankId))
                setBeneficiaryId({ label: data.accountName.toUpperCase() + " - " + data.bankCode + " (" + data.accountNo + ")", value: String(data.beneficiaryId) })
                setSourceName(data.sourceName)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getBankList = async () => {
        await apiGetBankList({
            data: {
                bankCode: EmptyString,
                bankName: EmptyString, 
                status: StatusCodeActive,
                pageSize: 1000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "Select Bank", value: "0" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
                    }

                    setBankOptions(tempArray)
                    setBankId(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getBeneficiaryList = async (search) => {
        await apiGetBeneficiaryList({
            data: {
                accountNo: EmptyString,
                accountName: search, 
                bankId: bankId === EmptyString ? "0" : bankId,
                status: status,
                pageSize: 100000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].accountName.toUpperCase() + " - " + data[i].bankCode + " (" + data[i].accountNo + ")", value: String(data[i].beneficiaryId) })
                    }

                    setBeneficiaryOptions(tempArray)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    if (formType === FormTypeAdd){
                        insertTransferSource().then(() => {
                            setLoading({isOpen: false})
                            onClose()
                        })
                    }else{
                        updateTransferSource().then(() => {
                            setLoading({isOpen: false})
                            onClose()
                        })
                    }
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const backBtnClick = () => {
        onClose()
    }

    function validateForm(){
        let errorCount = 0

        // if (bankId === EmptyString){
        //     setErrorBankId(true)
        //     errorCount++
        // }else{
        //     setErrorBankId(false)
        // }

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    useEffect(() => {        
        setLoading({ isOpen: true })

        if (formType === FormTypeEdit){
            getBankList().then(() => {
                getTransferSource().then(() => {
                    setLoading({ isOpen: false })
                })
            })            
        } else if (formType === FormTypeAdd) {
            getBankList().then(() => {
                setLoading({ isOpen: false })
            })
        } else {
            setLoading({ isOpen: false })
        }        
    }, [])

    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-40 rounded-lg">
            <div className='z-50 bg-white w-full h-full xl:h-auto xl:w-3/4 2xl:w-1/2 overflow-y-auto shadow-lg rounded-lg p-8'>
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">Transfer Source Detail</span>
                        <div className={`gap-2 items-end justify-end hidden sm:flex`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                            </span>
                        </div>
                    </div>
                </div>
                <hr />

                <div className="mt-5 flex flex-col gap-3">
                    {/* Bank */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Bank</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <Dropdown value={bankId} options={bankOptions} onChange={bankIdChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorBankId ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Bank is required!</span>
                        </div>
                    </div>

                    {/* Beneficiary Account */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Beneficiary Account</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72 md:w-[500px]">
                                    <Select options={beneficiaryOptions} onInputChange={beneficiaryOnInput} value={beneficiaryId} onChange={beneficiaryIdChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorBeneficiaryAccountNo ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Beneficiary Account No is required!</span>
                        </div>
                    </div>

                    {/* Source Name */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Source Name</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={sourceName} onChange={(e) => setSourceName(e.target.value.toUpperCase())} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorMdrOff ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Mdr Off Us is required!</span>
                        </div>
                    </div>
                </div>
                    

                <div className="mt-5 xl:mt-32 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <button
                        className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                        onClick={backBtnClick}
                    >
                        <span>Close</span>
                    </button>
                </div>
                
                {/* Modal */}
                {failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
                {loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
                {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
                {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
            </div>

            <div className="fixed top-0 bottom-0 left-0 right-0 bg-app-matte-black opacity-60 z-30" />
        </div>
    )
}